import React, { Component } from "react"
import PropTypes from "prop-types"

class InPlaceEditText extends Component {
  static propTypes = {
    staticText: PropTypes.string.isRequired,
    onConfirmClick: PropTypes.func,
  }

  constructor(props) {
    super(props)

    this.state = {
      inEdit: false,
      editedText: this.props.staticText,
    }
  }

  onCancelClick = () => {
    this.setState({
      editedText: this.props.staticText,
      inEdit: false,
    })
  }

  setEditMode = () => {
    this.setState({
      inEdit: true,
    })
  }

  handleOnChange = (e) => {
    this.setState({
      editedText: e.target.value,
    })
  }

  handleConfirmClick = () => {
    this.props.onConfirmClick(this.state.editedText)

    this.setState({
      inEdit: false,
    })
  }

  render() {
    const { staticText, onConfirmClick } = this.props

    return (
      <span>
        {this.state.inEdit && (
          <span>
            <span className="fa fa-check" onClick={this.handleConfirmClick} />
            &nbsp;
            <span className="fa fa-ban" onClick={this.onCancelClick} />
            &nbsp; &nbsp;
            <input type="text" value={this.state.editedText} onChange={this.handleOnChange} />
          </span>
        )}
        {!this.state.inEdit && (
          <span>
            {onConfirmClick && <span className="fa fa-pencil" onClick={this.setEditMode} />}
            &nbsp;
            <span>{staticText}</span>
          </span>
        )}
      </span>
    )
  }
}

export default InPlaceEditText



// WEBPACK FOOTER //
// ./src/components/inputs/InPlaceEditText.jsx